<template>
<div v-if="createForm" class="comment"
     :class="{'comment--reply': parentId}">
  <q-form @submit="submitCreate" @reset="resetAndClose">
    <input type="hidden" name="_token" :value="$csrfToken" />
    <input type="hidden" name="phase_id" :value="phaseId">
    <input type="hidden" name="parent_id" :value="parentId">
    <input type="hidden" name="project_id" :value="projectId">
    <input type="hidden" name="rule_id" :value="ruleId">
    <input type="hidden" name="rule_version_id" :value="ruleVersionId">
    <input type="hidden" name="object_id" :value="objectId">

    <div v-if="parentId" class="row items-center q-mt-sm">
      {{ replyToName }}
    </div>
    <div v-else class="row items-center no-wrap q-gutter-x-md">
      <common-avatar size="sm" :user="currentUser" />
      <div class="text-neutral-60 text-small">
        <div class="comment__user">
          {{ currentUser ? $fullName(currentUser) : '-' }}
        </div>
      </div>
    </div>
    <div class="comment__content">
      <common-input name="body" v-model="body" label="Typ hier" type="textarea"
                    :error-message="$errorMessage('body')"
                    :error="$hasError('body')"
                    autofocus
                    required
      />
    </div>
    <div class="comment__actions">
      <primary-button label="Plaatsen" class="q-mr-sm" type="submit" />
      <flat-button label="Annuleren" type="reset" />
    </div>
  </q-form>
</div>
</template>

<script>
import { useProjectComents } from '../../stores/useProjectComments'

export default {
  data () {
    return {
      body: '',
    }
  },
  setup () {
    const projectComments = useProjectComents()
    return {
      projectComments,
    }
  },
  props: {
    parentId: {
      type: Number,
    },
    phaseId: {
      type: Number,
    },
    projectId: {
      type: Number,
    },
    objectId: {
      type: Number,
    },
    ruleId: {
      type: Number,
      default: null,
    },
    ruleVersionId: {
      type: Number,
    },
    commentUserName: {
      type: String,
    },
    createForm: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    replyToName () {
      let name = this.commentUserName

      name = name.length > 12 ? name.substring(0, 10) + '..' : name

      return '@' + name
    },
  },
  emits: ['update:createForm'],
  methods: {
    resetAndClose () {
      this.$emit('update:createForm', false)
      this.body = ''
    },
    submitCreate () {
      let comment = {
        phase_id: this.phaseId,
        parent_id: this.parentId,
        project_id: this.projectId,
        rule_id: this.ruleId,
        rule_version_id: this.ruleVersionId,
        object_id: this.objectId,
        body: this.body,
      }

      axios.post(route('api.comment.store'), comment).then(({ data }) => {
        this.projectComments.reload()
        this.resetAndClose()
      }).catch(error => {
        if (error.response.status === 422) {
          // TODO what do?
          console.log(error.response.data.errors)
          // this.errors = error.response.data.errors || {}
        }
      })
    },
  },
}
</script>
